var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"space-around"}},[_c('v-icon',[_vm._v("fas fa-lock")]),_c('v-icon',[_vm._v("fas fa-search")]),_c('v-icon',[_vm._v("fas fa-list")]),_c('v-icon',[_vm._v("fas fa-edit")]),_c('v-icon',[_vm._v("fas fa-tachometer-alt")]),_c('v-icon',[_vm._v("fas fa-circle-notch fa-spin")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }